import { NavLink, useLocation } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';

const navItems = [
  { path: '/', icon: 'ri-dashboard-line', activeIcon: 'ri-dashboard-fill', label: 'Ana Sayfa' },
  { path: '/fizbo', icon: 'ri-map-pin-line', activeIcon: 'ri-map-pin-fill', label: 'FİZBO' },
  { path: '/portfoy', icon: 'ri-building-line', activeIcon: 'ri-building-fill', label: 'Portföy' },
  { path: '/musteri-rehber', icon: 'ri-user-line', activeIcon: 'ri-user-fill', label: 'Müşteri' },
  { path: '/ayarlar', icon: 'ri-settings-3-line', activeIcon: 'ri-settings-3-fill', label: 'Ayarlar' },
];

export default function BottomNav() {
  const { isDark } = useTheme();
  const location = useLocation();

  return (
    <nav
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden ${
        isDark ? 'bg-dark-card border-t border-dark-border' : 'bg-white border-t border-light-border'
      }`}
    >
      <div className="flex items-center justify-around py-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-0.5 py-1 px-3 rounded-lg transition-colors ${
                isActive ? 'text-primary-500' : isDark ? 'text-dark-muted' : 'text-light-muted'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${isActive ? item.activeIcon : item.icon} text-lg`} />
              </div>
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}